export default [
  'accounting2@foodforjoe.es',
  'daniel.garrido@foodforjoe.es',
  'mtro@tax.es',
  'daniel@wedo-solutions.com',
  'office@wedo-solutions.com',
];
